import {Options, Vue} from 'vue-class-component'
import LegacyIcon from "@/components/LegacyIcon.vue";
import Modal from "@/components/Modal.vue";
import SupplierLogin from "@/components/supplier-login/SupplierLogin.vue";
import MaskedInput from "@/components/MaskedInput.vue";
import {cpfCnpjMask} from "@/constants";
import AccountService from "@/services/AccountService";
import {IUser} from '@/shared/domain/user.model';

@Options({
  data: function () {
    return {
      cpfCnpjMask,
      loginModalVisible: false,
      showResetPasswordModal: false,
      resetPasswordResponse: null,
      showSupplierLoginModal: false,
      loginInvalid: false,
      login: {
        cpf: '',
        email: '',
        password: ''
      },
      checkCpfStatus: null,
      sidebarPrimaverasVisible: false
    }
  },
  components: {
    LegacyIcon,
    Modal,
    MaskedInput,
    SupplierLogin
  },
  props: {
    sidebarVisible: {
      default: false,
      type: Boolean,
    },
  },
  emits: [
    "update:sidebarVisible"
  ],
  methods: {
    openCloseSidebar() {
      this.$emit('update:sidebarVisible', !this.sidebarVisible);
    },
    closeResetPasswordModal() {
      this.resetPasswordResponse = null;
      this.login.email = "";
      this.showResetPasswordModal = false;
    },
    sidebarLoginName() {
      if (this.isLogged) {
        return 'sidebar.dashboard';
      } else {
        return 'sidebar.login';
      }
    },
    getSidebarItemName(item: any) {
      if (item.nameMethod) {
        return this[item.nameMethod]();
      } else {
        return item.name;
      }
    },
    clearFailMessage() {
      this.checkCpfStatus = null;
      this.loginInvalid = false;
    },
    clickLoginButton() {
      if (this.user) {
        this.$router.replace('/contracts');
      } else {
        this.loginModalVisible = true;
        this.login.cpf = '';
        this.login.password = '';
        this.checkCpfStatus = null;
        this.login.email = '';
        this.loginInvalid = false;
      }
    },
    openUserLoginModal() {
      this.showSupplierLoginModal = false;
      this.clickLoginButton();
    },
    openSupplierLoginModal() {
      this.showSupplierLoginModal = true;
      this.clickLoginButton();
    },
    checkCpf(value: string) {
      this.login.cpf = value;
      if (value.length >= 11) {
        const cpfDigitsOnly = value.replace(/\D/g, '');
        AccountService.checkCpf(cpfDigitsOnly).then((res) => {
          if (res) {
            this.checkCpfStatus = res.data;
          }
        });
      } else {
        this.checkCpfStatus = null;
      }
    },
    resetPassword() {
      if (this.isEmailValid) {
        AccountService.resetPassword(this.login.email).then(() => {
          this.resetPasswordResponse = true;
        }, () => {
          this.resetPasswordResponse = false;
        });
      }

    },
    onClickForgotPassword() {
      this.loginModalVisible = false;
      this.showResetPasswordModal = true;
    },
    doLogin() {
      if (this.login.password != null && this.login.password.length > 0 && !this.failLogin) {
        if (this.showSupplierLoginModal) {
          AccountService.funeralSupplierLogin(this.login.email, this.login.password).then((res) => {
            if (res && res.data) {
              this.clearFailMessage();
            } else {
              this.loginInvalid = true;
            }
            this.loading = false;
          }, () => {
            this.loginInvalid = true;
            this.loading = false;
          })
        } else {
          AccountService.login(this.login.cpf, this.login.password).then((res) => {
            if (res && res.data) {
              console.log("Login success");
              const user = res.data;
              this.$store.commit('changeUser', user);
              this.loginModalVisible = false;
              this.$router.replace("/contracts");
            }
          }, () => {
            console.log("Login failed");
            this.loginInvalid = true;
            this.$store.commit('changeUser', null);
          })
        }

      }
    },
    clickLogoutButton() {
      AccountService.logout();
      this.$router.replace('/');
    },
    changeLang(locale: string): void {
      this.$i18n.locale = locale;
      if (this.$root) {
        this.$root.$i18n.locale = locale
      }
    },
    doSidebarItemFunction(sidebarItem: any) {
      if (sidebarItem.name === 'home.title') {
        if (this.$store.getters.getFuneralSupplierIdFilter) {
          window.location.replace("https://www.legacyfuneral.com.br?s=" + this.$store.getters.getFuneralSupplierIdFilter);
        } else if (this.$store.getters.getLegacySupplierCompaniesIdFilter) {
          window.location.replace("https://www.legacyfuneral.com.br?s=" + this.$store.getters.getLegacySupplierCompaniesIdFilter);
        } else if (this.$store.getters.getCommissionCode) {
          window.location.replace("https://www.legacyfuneral.com.br?cKey=" + this.$store.getters.getCommissionCode);
        } else {
          window.location.replace("https://www.legacyfuneral.com.br");
        }
      }
      if (sidebarItem.routerLink) {
        this.openCloseSidebar();
        this.$router.replace(sidebarItem.routerLink);
      } else if (sidebarItem.href) {
        window.open(sidebarItem.href);
      } else if (sidebarItem.method) {
        this[sidebarItem.method]();
      }
    }
  },

  computed: {
    failLogin() {
      return (this.checkCpfStatus !== null && this.checkCpfStatus === false) || this.loginInvalid;
    },
    sidebarItems() {
      const loggedUserItems = [
        {
          name: 'account.title',
          routerLink: '/account'
        },
        {
          name: 'sidebar.logout',
          method: 'clickLogoutButton',
        },

      ];

      const notLoggedUserItems = [
        /*{
          nameMethod: 'sidebarLoginName',
          method: 'openUserLoginModal',
          child: [
            {
              name: 'ACESSE'
            }
          ]
        },*/
        {
          name: 'sidebar.supplierLogin',
          method: 'openSupplierLoginModal',
          child: [
            {
              name: 'FORNECEDORES & INSTITUIÇÕES'
            }
          ]
        },
        {
          name: 'sidebar.supplier',
          href: 'https://www.legacyfuneral.com.br/seja-parceiro/',
          child: [
            {
              name: 'CADASTRE-SE'
            }
          ]
        },
        {
          name: 'sidebar.hospital',
          href: 'https://www.legacyfuneral.com.br/seja-parceiro-hospitais/',
          child: [
            {
              name: 'CADASTRE-SE'
            }
          ]
        },
        {
          name: 'sidebar.blog',
          href: 'https://blog.legacyfuneral.com.br/',
        },
      ];

      let items = [
        {
          name: 'home.title',
          href: '/'
        },
        {
          name: 'home.lost_someone_title',
          routerLink: '/imediato/fornecedor',
          child: [
            {
              name: 'CONTRATE AGORA'
            }
          ]
        },
        {
          name: 'home.prevent_title',
          routerLink: '/plano/fornecedor',
          child: [
            {
              name: 'CONTRATE AGORA'
            }
          ]
        },
        /*{
          name: 'sidebar.insurance',
          routerLink: '/',
          child: [
            {
              name: 'EM BREVE DISPONÍVEL',
            }
          ]
        },*/
      ] as any[];
      if (this.isLogged) {
        items = items.concat(loggedUserItems);
      } else {
        items = items.concat(notLoggedUserItems);
      }
      return items;

    },
    notMainRoot() {
      return this.$route.path !== "/";
    },
    user(): IUser {
      return this.$store.getters.getUser;
    },
    isLogged(): boolean {
      return this.user;
    },
    hasHeaderLogo(): boolean {
      return !this.$route.meta.noHeaderLogo;
    },
    isEmailValid() {
      return this.login && /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.login.email);
    }
  },
})
export default class HeaderComponent extends Vue {


}
